if(document.querySelector('#typed')) {
	var typed = new Typed('#typed', {
		stringsElement: '#typed-strings',
		loop: true,
		typeSpeed: 50,
		backDelay: 1000
	});
}